import styled from 'styled-components';

import { columnFlex } from 'core/styles';

export const RoutingContainer = styled.div<{ $isDetailsView: boolean }>`
  ${columnFlex};
  overflow-y: ${(props) => (props.$isDetailsView ? 'visible' : 'auto')};
  margin-bottom: ${(props) => (props.$isDetailsView ? '20px' : '60px')};
`;
